/**
 * 真偽判定(0含まない)
 */
export const isNonNumericFalsyValue = (value) => !value && value !== 0;
/**
 * 数値かどうか
 */
export const isNotEmptyNumber = (value) => value !== undefined && value !== null && !Number.isNaN(value);
